import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { developerFactsSelector } from 'shared/selectors/specialPromosBlocks/developerFactsSelector';

import { Facts } from './Facts';
import { trackShowFactsSection } from './internal/tracking/trackShowFactsSection';

export const FactsContainer: FC = () => {
  const facts = useSelector(developerFactsSelector);

  if (!facts.length) {
    return null;
  }

  return <Facts facts={facts} isShort={facts.length < 4} onView={() => trackShowFactsSection(facts)} />;
};
